import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button"; // Import Button
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import DataTable from "common/Tables/DataTable";
import studiosTableData from "layouts/tables/data/studiosTableData";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDealers } from "store/slice/dealersSlice";
import { useNavigate } from "react-router-dom";
import { getStudios } from "store/slice/studiosSlice";

function Studios() {
  const studios = useSelector((store) => store.studios);
  const navigate = useNavigate();

  const editAction = (game) => {
    navigate(`/studios/${game.id}`);
  };

  const { columns, rows } = studiosTableData({
    studios: studios.studios,
    editAction,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStudios());
  }, []);

  const handleAddGame = () => {
    navigate("/studios/new"); // Navigate to the page to create a new game
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item size={{xs: 12}}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Studio
                </MDTypography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddGame} // Add click handler
                >
                  Add Studio
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Studios;
